import { useMutation } from '@tanstack/react-query';
import { useFetch } from '@/hooks/useFetch';
import type { ErrorResponse } from '@/types/apiTypes';
import type { EditClientData, EditClientResponse } from '@/types/clientsApiTypes';

export const useEditClientMutation = () => {
  const { doFetch } = useFetch<Partial<EditClientData>, EditClientResponse>();

  return useMutation<EditClientResponse, ErrorResponse<unknown>, { data: Partial<EditClientData>, clientId: number }>({
    mutationFn: ({ data, clientId }: { data: Partial<EditClientData>, clientId: number }) => {
      return doFetch(`/api/client-details/${clientId}`, {
        method: 'PATCH',
        body: data,
      });
    },
  });
};
